import React from 'react';
import OpenCloseButton from '../../../ui/OpenCloseButton';
import styles from './pressPlayTeaser.module.scss';

const PressPlayTeaser = props => {
  const { title, label, setActiveDetail, isActive, imageSrc, alt } = props;

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <div className={styles.imageContainerInner}>
          <img className={styles.image} src={imageSrc} alt={alt} />
          <div
            className={!isActive ? styles.buttonWrap : styles.buttonWrapClosed}
          >
            <OpenCloseButton
              clicked={isActive}
              onClick={setActiveDetail.bind(null, props)}
            />
          </div>
        </div>
      </div>
      <div className={styles.contentContainer}>
        {title.length && (
          <h4
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {label && (
          <p
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </div>
    </div>
  );
};

export default PressPlayTeaser;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/PressPlayTeaser.js